import { render, staticRenderFns } from "./NewRoleModal.vue?vue&type=template&id=3d0c8036&scoped=true&"
import script from "./NewRoleModal.vue?vue&type=script&lang=js&"
export * from "./NewRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./NewRoleModal.vue?vue&type=style&index=0&id=3d0c8036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c8036",
  null
  
)

export default component.exports